<template lang="pug">
  section.solution
    h1(:class="titleAnimation") 解决方案
    h2 THE SOLUTION
    .ops
      div(v-for="(item, index) in solutions" :class="['background-' + index]" @click="gotoSolution(item.title)")
        .solutionTitle(:class="[bigFont(!item.text), contentAnimation, `animateDelay-${index}`]") {{ item.title }}
        p(v-show="item.text && contentIsShow" :class="[contentAnimation, `animateDelay-${index}`]") {{ item.text }}
</template>

<script>
  import Mixin from "../../index";
  
  export default {
    name: "solutions",
    mixins: [Mixin],
    data() {
      return {
        solutions: [
          {title: '数字城市', text: 'DIGITAL CITY'},
          {title: '数字教育', text: 'DIGITAL EDUCATION'},
          {title: 'AIoT'},
          {title: '精准营销', text: 'MARKETING'},
          {title: '个性化推荐', text: 'PERSONALIZED\nRECOMMENDATION'},
        ],
        contentTop: 300,
      };
    },
    methods: {
      bigFont(val) {
        return {bigFont: val};
      },
      gotoSolution(title) {
        const solution = {
          '数字城市': 'DigitalCity',
          '数字教育': 'DigitalEducation',
          'AIoT': 'FaceSaaS',
          '精准营销': 'PrecisionMarketing',
          '个性化推荐': 'Recommendation',
        };
        window.scrollTo(0, 0);
        this.$router.push({name: solution[title]});
      },
    }
    
    
  };
</script>

<style scoped lang="stylus">
  @import "../../index.styl"
  .solutionTitle {
    font-size 48px
    FontSetting("Source Han Sans CN Regular")
  }
  .bigFont {
    font-size 100px
  }
  .solution {
    padding 100px 0 0
    display flex
    flex-direction column
    align-items center
    justify-content flex-start
    width 100%
    
    .background {
      background url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88.png") no-repeat center
      background-size 100%
      width 100%
      height 22.4vw
      display flex
      justify-content space-around
      align-items center
    }
    Background(index) {
      /*background url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88.png") no-repeat*/
      if (index == 0) {
        background url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E6%95%B0%E5%AD%97%E5%9F%8E%E5%B8%82.png")
      } else if (index == 1) {
        background url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E6%95%B0%E5%AD%97%E6%95%99%E8%82%B2.png")
      } else if (index == 2) {
        background url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88.png")
      } else if (index == 3) {
        background url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E7%B2%BE%E5%87%86%E8%90%A5%E9%94%80.png")
      } else if (index == 4) {
        background url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E4%B8%AA%E6%80%A7%E5%8C%96%E6%8E%A8%E8%8D%90.png")
      }
      background-size auto 100%
      background-repeat no-repeat
      height 22.5vw
      background-position center
      transition all .3s
      &:hover {
        background-size auto 120%
      }
    }
    .background-0 {
      // 数字城市
      Background(0)
    }
    .background-1 {
      // 数字教育
      Background(1)
    }
    .background-2 {
      // iot
      Background(2)
    }
    .background-3 {
      // 精准营销
      Background(3)
    }
    .background-4 {
      // 个性化推荐
      Background(4)
    }
    
    .ops {
      HStack(center, space-around)
      height 22.5vw
      width 100%
      @media (max-width 1050px) {
        .solutionTitle {
          font-size 36px
        }
        .bigFont {
          font-size 80px
        }
      }
      @media (max-width 950px) {
        .solutionTitle {
          font-size 24px
        }
        .bigFont {
          font-size 60px
        }
      }
      
      > div {
        flex-grow 1
        width 20%
        VStack(center, center)
        cursor pointer
        
        div, > p {
          color white
        }
        
        > p {
          font-size 24px
          text-align center
          FontSetting(Montserrat)
          font-weight 200
        }
        
        &:hover {
        }
      }
    }
    @media (max-width ipadProScreenWidth) {
      .solutionTitle {
        font-size 40px
      }
      .ops > div > p {
        font-size 16px
      }
      .bigFont {
        font-size 80px
      }
    }
    
    @media (max-width screenWidth) {
      width 100vw
      padding 50px 0 0
      h1 {
        font-size 24px
        padding 0
        margin-bottom 20px
      }
      .ops {
        width 100%
        height 232.8px
        HStack(center)
        overflow auto
        > div {
          width 253.2px
          height 232.8px
          flex-shrink 0
          .solutionTitle {
            font-size 30px
          }
          p {
            font-size 20px
          }
        }
        .background-0, .background-1, .background-2, .background-3, .background-4 {
          background-size 100%
        }
        .background-2 {
          background-size 500%
        }
      }
      
    }
  }
  .animateDelay-0 {
    animation-delay 0
  }
  .animateDelay-1 {
    animation-delay 100ms
  }
  .animateDelay-2 {
    animation-delay 200ms
  }
  .animateDelay-3 {
    animation-delay 300ms
  }
  .animateDelay-4 {
    animation-delay 400ms
  }
</style>
